module.exports = __webpack_public_path__ + "img/Group 6850@2x.6a5bf5d1.png";